<template>
  <div ref="dropdownElement" class="dropdown" @click="clearSearch()">
    <slot name="toggle"></slot>
    <ul class="dropdown-menu my-1">
      <template v-if="props.searchable !== null">
        <li class="px-2">
          <input
            :id="searchable"
            v-model="searchInput"
            type="text"
            class="form-control"
            placeholder="Search"
            :aria-label="translate('Search')"
            data-testid="dropdown-select.search.input"
            @input="search($event)"
          />
        </li>
        <li><hr class="dropdown-divider" /></li>
      </template>
      <div class="scrollable-menu custom-scrollbar">
        <slot name="items"></slot>
      </div>
    </ul>
  </div>
</template>

<script setup>
import Dropdown from 'bootstrap/js/dist/dropdown.js';

const props = defineProps({
  searchable: {
    type: String,
    default: null,
  },
});

const {translate} = useLocalisation();

const dropdownElement = ref(null);
const searchInput = ref('');

onMounted(() => {
  if (dropdownElement.value) {
    new Dropdown(dropdownElement.value.children[0], {
      offset: [0, 0],
      popperConfig: {
        placement: 'auto',
        strategy: 'fixed',
      },
    });
  }
});

// search function for dropdown items
const search = (e) => {
  const input = e.target.value.toLowerCase();
  const items = dropdownElement.value.querySelectorAll('.dropdown-item');
  items.forEach((item) => {
    if (item.textContent.toLowerCase().indexOf(input) > -1) {
      item.classList.remove('d-none');
    } else {
      item.classList.add('d-none');
    }
  });
};

// if dropdown is toggled clear search input and show all items
const clearSearch = () => {
  if (searchInput.value !== '') {
    searchInput.value = '';
    search({target: searchInput});
  }
};
</script>
<style lang="scss" scoped>
.dropdown-menu {
  --bs-dropdown-border-width: 0;

  box-shadow: var(--bs-box-shadow-sm);
}
</style>
